/**
 * @generated SignedSource<<b4ebbc11f0f604f2c8f4309f367c426a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentLiveArticleLiveArticle$data = {
  readonly liveContents: ReadonlyArray<{
    readonly customTime: number | null | undefined;
    readonly entityUuid: string;
    readonly " $fragmentSpreads": FragmentRefs<"itemLiveArticleContentLiveContent">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "contentLiveArticleLiveArticle";
};
export type contentLiveArticleLiveArticle$key = {
  readonly " $data"?: contentLiveArticleLiveArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentLiveArticleLiveArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentLiveArticleLiveArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LiveContent",
      "kind": "LinkedField",
      "name": "liveContents",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityUuid",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "itemLiveArticleContentLiveContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LiveArticle",
  "abstractKey": null
};

(node as any).hash = "06807a20e291b01209119cc5b6f5c8b3";

export default node;
